export const mouLightLogo = process.env.REACT_APP_MOU_LOGO_LIGHT;
export const mouDarkLogo = process.env.REACT_APP_MOU_LOGO_DARK;